import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMinimize45: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconMinimize45"><Path d="M13.5 3.5V10.5H20.5" stroke="currentColor" strokeLinecap="square"/><Path d="M10.5 20.5V13.5H3.5" stroke="currentColor" strokeLinecap="square"/><Path d="M14 10L20.5 3.5" stroke="currentColor" strokeLinecap="square"/><Path d="M10 14L3.5 20.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconMinimize45;
